import { Observable } from 'rxjs'
import { FeathersEvent } from './API'
import Job from './Job'
import Message from 'messaging/models/Message'
import { FetchJob } from './JobStore'
import { mergeMap } from 'rxjs/operators'
import { max } from 'date-fns'
import { filterNonNil } from 'utils/rx-util'

/**
 * Synthesizes Job Update events from new message events.
 *
 * @param newMessages$
 * @param fetchJob
 */
export function SynthesizedJobUpdates(
  newMessages$: Observable<Message>,
  fetchJob: FetchJob,
): Observable<FeathersEvent<Job>> {
  return newMessages$.pipe(
    mergeMap(async (message): Promise<FeathersEvent<Job> | null> => {
      if (message.conversation.meta.type !== 'Job') {
        return null
      }
      const job = await fetchJob(message.conversation.meta.id).catch(
        // Don't crap out in case there's an error.
        () => null,
      )
      if (!job) {
        return null
      }

      // Always emit the `patch` event but use the latest modified.
      const newModified = max([message.dateCreated, job.dateModified])
      job.setModified(newModified)
      return {
        event: 'patched',
        data: job,
      }
    }),
    filterNonNil(),
  )
}
